import { oxygenPlusConcentratorType } from "../../../../../../../shared_lsi_sg/oxygenPlusConcentratorData";
import { required } from "../../../../../../../shared/utils/forms/utils/validationType";
import { useValidationOxygen } from "./useValidationOxygen";

const buildConcentratorFlowValidations = (prefix: string, t: any) => ([
  {
    name: `${prefix}.flowRest`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.flowRest")
        }
      }
    ]
  },
  {
    name: `${prefix}.flowRestHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  },
  {
    name: `${prefix}.underStressFlow`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.underStressFlow")
        }
      }
    ]
  },
  {
    name: `${prefix}.underStressFlowHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  },
  {
    name: `${prefix}.nightFlow`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.nightFlow")
        }
      }
    ]
  },
  {
    name: `${prefix}.nightFlowHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  }
]);

export const useValidationOxygenPlusConcentrator = (t: any, dataForm: any) => {
  const validations = [
    {
      name: "oxygenPlusConcentratorType",
      validations: [
        {
          name: required,
          params: {
            name: t("oxygenPlusConcentrator.tipologia")
          }
        }
      ]
    },
    ...useValidationOxygen(t, dataForm),
    ...(dataForm?.oxygenPlusConcentratorType === oxygenPlusConcentratorType.oxygen_portable
      ? buildConcentratorFlowValidations("portable", t)
      : []),
    ...(dataForm?.oxygenPlusConcentratorType === oxygenPlusConcentratorType.oxygen_transportable
      ? [
        {
          name: "transportable.flowType",
          validations: [
            {
              name: required,
              params: {
                name: t("prescription.template.flowType.label")
              }
            }
          ]
        },
        ...buildConcentratorFlowValidations("transportable", t)
      ]
      : [])
  ];

  return validations;
};
